<div class="compra-container">

  <h1 class="title">COMPRA UNA FOTO CON NUESTROS JUGADORES</h1>
  <span class="sub-header">Aquí podrá comprar fotos para que sus hijos o los menores de los que esté a cargo</span>

  <!--STEPPER-->
  <div class="step-bar-container">

    <div class="step" [ngClass]="stepInfo.steps[0].state">
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.5" cy="12.5" r="12.5" fill="#008835"/>
        <path d="M8.896 8.592V7.296L12.416 6.704H13.504V16.784H16.72V18H8.896V16.784H12.096V8.128L8.896 8.592Z"
              fill="white"/>
      </svg>
      Complimente la información
    </div>

    <div class="step" [ngClass]="stepInfo.steps[1].state">
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12.5" cy="12.5" r="12.5" fill="#008835" />
        <path d="M15.232 9.792C15.232 9.14133 15.0293 8.656 14.624 8.336C14.2187 8.00533 13.6107 7.84 12.8 7.84C11.9893 7.84 11.376 8.02667 10.96 8.4C10.544 8.76267 10.336 9.30133 10.336 10.016V10.288H8.976V9.952C8.976 8.91733 9.30667 8.10667 9.968 7.52C10.64 6.92267 11.5947 6.624 12.832 6.624C14.08 6.624 15.024 6.896 15.664 7.44C16.3147 7.984 16.64 8.768 16.64 9.792C16.64 10.5173 16.4693 11.136 16.128 11.648C15.7973 12.16 15.2533 12.5867 14.496 12.928L11.808 14.128C11.2853 14.3733 10.9333 14.6347 10.752 14.912C10.5707 15.1893 10.48 15.5573 10.48 16.016V16.784H16.72V18H9.088V15.904C9.088 15.2427 9.22667 14.688 9.504 14.24C9.78133 13.7813 10.24 13.408 10.88 13.12L13.904 11.76C14.3733 11.536 14.7093 11.264 14.912 10.944C15.1253 10.624 15.232 10.24 15.232 9.792Z" fill="white" />
      </svg>
      Pasar al pago
    </div>

    <div class="step" [ngClass]="stepInfo.steps[2].state">

      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">

        <circle cx="12.5" cy="12.5" r="12.5" fill="#008835" />
        <path
          d="M16.608 14.72C16.608 15.84 16.2773 16.6987 15.616 17.296C14.9653 17.8827 14.0053 18.176 12.736 18.176C11.4987 18.176 10.5493 17.9093 9.888 17.376C9.23733 16.8427 8.912 16.0907 8.912 15.12V14.784H10.272V15.056C10.272 15.696 10.4747 16.1813 10.88 16.512C11.296 16.832 11.9093 16.992 12.72 16.992C13.552 16.992 14.1707 16.8 14.576 16.416C14.992 16.032 15.2 15.4453 15.2 14.656C15.2 14.0053 15.0027 13.5093 14.608 13.168C14.224 12.8267 13.6587 12.656 12.912 12.656H11.312V11.584H12.976C13.616 11.584 14.1067 11.424 14.448 11.104C14.8 10.784 14.976 10.32 14.976 9.712C14.976 9.08267 14.784 8.608 14.4 8.288C14.016 7.968 13.4453 7.808 12.688 7.808C11.9307 7.808 11.36 7.968 10.976 8.288C10.592 8.608 10.4 9.08267 10.4 9.712V9.968H9.024V9.648C9.024 8.69867 9.344 7.95733 9.984 7.424C10.624 6.89067 11.536 6.624 12.72 6.624C13.9147 6.624 14.8213 6.88533 15.44 7.408C16.0587 7.92 16.368 8.66133 16.368 9.632C16.368 10.176 16.2453 10.6613 16 11.088C15.7653 11.504 15.4293 11.8347 14.992 12.08C15.504 12.3147 15.8987 12.6613 16.176 13.12C16.464 13.5787 16.608 14.112 16.608 14.72Z"
          fill="white"
        />
      </svg>

      Hecho
    </div>
  </div>

  <div class="compra-content scroll-container">

    <span [ngSwitch]="currentStep">

      <span *ngSwitchCase="1">

        <!--TIMER-->
        <div [ngClass]="{ hidden: !showTimer, alert: isExpiringSoon }" class="timer-container">
          <mat-icon>timer</mat-icon>
          <a>{{ countdownText }}</a>
        </div>

        <!--SELECCIONE UN PARTIDO-->
        <span>

          <span class="menores-content-subtitle">Seleccione un partido</span>

          <div class="retry-dropdown-container">

              <div class="seleccionar-partido-content">

              <div class="select-spaced container-padding">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Próximos partidos en casa</mat-label>
                  <mat-select
                    [(ngModel)]="selectedPartido"
                    [disabled]="partidoDisabled"
                    (selectionChange)="onPartidoSeleccionado()"
                  >
                    <mat-option *ngFor="let partido of partidos" [value]="partido.id">
                      {{ formatPartidoLiteral(partido.name, partido.edate) }}
                    </mat-option>
                  </mat-select>

                  <!-- Botón de retry -->
                  <button mat-icon-button matSuffix color="primary" *ngIf="showPartidoRetry" (click)="callPartidos()"
                    matTooltip="Volver a intentar">
                    <mat-icon>refresh</mat-icon>
                  </button>

                  <!-- Botón de reset -->
                  <button mat-icon-button matSuffix color="primary" *ngIf="selectedPartido"
                    (click)="resetPartidoProcess()" matTooltip="Cambiar partido seleccionado (¡reiniciará el proceso!)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <div>

              </div>

            </div>

          </div>

        </span>

        <!--CUANTAS ENTRADAS-->
        <span>

          <span class="menores-content-subtitle">¿Cuántas entradas?</span>

          <div class="retry-dropdown-container">

            <div class="select-spaced container-padding">

              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Número de entradas</mat-label>

                <mat-select [(ngModel)]="selectedNumeroEntradas" (selectionChange)="onEntradasSelected($event.value)"
                  [disabled]="!entradasInfo || entradasInfo.stockAvailable === 0 || entradasDisabled">
                  <mat-option *ngFor="let n of [].constructor(getEntradasAvailableToBuy() || 0); let i = index"
                    [value]="i + 1">
                    {{ i + 1 }}
                  </mat-option>
                </mat-select>

                <button mat-icon-button matSuffix color="primary" *ngIf="showEntradasRetry" (click)="callEntradas()"
                  matTooltip="Volver a intentar">
                  <mat-icon>refresh</mat-icon>
                </button>

                <button mat-icon-button matSuffix color="primary" *ngIf="selectedNumeroEntradas != 0"
                  (click)="resetEntradasProcess()" matTooltip="Volver a seleccionar el número de entradas">
                  <mat-icon>delete</mat-icon>
                </button>

                <!-- Hints -->
                <mat-hint *ngIf="entradasInfo && !selectedNumeroEntradas && entradasInfo.stockAvailable > 0">
                  Una vez seleccionadas las entradas, si cambia de opinión se reseteará el formulario
                </mat-hint>

                <mat-hint *ngIf="entradasInfo && selectedNumeroEntradas && entradasInfo.stockAvailable > 0">
                  Si quiere cambiar el número de entradas, resetee el formulario con el icono derecho
                </mat-hint>

                <mat-hint *ngIf="entradasInfo && entradasInfo.stockAvailable === 0" style="color: #d32f2f;">
                  No quedan entradas disponibles
                </mat-hint>

              </mat-form-field>

            </div>

          </div>

        </span>

        <!--USER INFO FORM-->
        <div>

          <span class="menores-content-subtitle">Rellene su información</span>

          <!--FORM-->
          <div class="comprador-form-container">
            <form [formGroup]="compradorForm" class="comprador-form">

              <!-- Nombre -->
              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>person</mat-icon>&nbsp;Nombre</mat-label>
                <input matInput placeholder="Tu nombre" formControlName="nombreComprador" required>
                <mat-error *ngIf="compradorForm.get('nombreComprador')?.hasError('required')">
                  El nombre es obligatorio
                </mat-error>
              </mat-form-field>

              <!-- Apellidos -->
              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>badge</mat-icon>&nbsp;Apellidos</mat-label>
                <input matInput placeholder="Tus apellidos" formControlName="apellidosComprador" required>
                <mat-error *ngIf="compradorForm.get('apellidosComprador')?.hasError('required')">
                  Los apellidos son obligatorios
                </mat-error>
              </mat-form-field>

              <!-- DNI -->
              <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>fingerprint</mat-icon>&nbsp;DNI</mat-label>
                <input matInput placeholder="Documento de identidad" formControlName="dniComprador" required>
                <mat-error *ngIf="compradorForm.get('dniComprador')?.hasError('required')">
                  El DNI es obligatorio
                </mat-error>
              </mat-form-field>

              <!-- Email -->
              <!-- <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>email</mat-icon>&nbsp;Email</mat-label>
                <input matInput type="email" placeholder="correo@ejemplo.com" formControlName="emailComprador" required>
                <mat-error *ngIf="compradorForm.get('emailComprador')?.hasError('required')">
                  El email es obligatorio
                </mat-error>
                <mat-error *ngIf="compradorForm.get('emailComprador')?.hasError('email')">
                  Introduce un email válido
                </mat-error>
              </mat-form-field> -->

              <!-- Teléfono -->
              <!-- <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>phone</mat-icon>&nbsp;Teléfono</mat-label>
                <input matInput type="tel" placeholder="Ej: 600 123 456" formControlName="telefonoComprador" required>
                <mat-error *ngIf="compradorForm.get('telefonoComprador')?.hasError('required')">
                  El teléfono es obligatorio
                </mat-error>
              </mat-form-field> -->
                <!-- Domicilio -->
              <!-- <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>home</mat-icon>&nbsp;Domicilio</mat-label>
                <input matInput placeholder="Calle, número, piso..." formControlName="domicilioComprador" required>
                <mat-error *ngIf="compradorForm.get('domicilioComprador')?.hasError('required')">
                  El domicilio es obligatorio
                </mat-error>
              </mat-form-field> -->

              <!-- Código Postal -->
              <!-- <mat-form-field appearance="outline" class="form-field">
                <mat-label><mat-icon>markunread_mailbox</mat-icon>&nbsp;Código Postal</mat-label>
                <input matInput placeholder="Ej: 41001" formControlName="codigoPostalComprador" required>
                <mat-error *ngIf="compradorForm.get('codigoPostalComprador')?.hasError('required')">
                  El código postal es obligatorio
                </mat-error>
                <mat-error *ngIf="compradorForm.get('codigoPostalComprador')?.hasError('codigoPostal')">
                  Introduce un código postal válido
                </mat-error>
              </mat-form-field> -->

            </form>
          </div>

        </div>

        <!--INFORMACION MENORES-->
        <span [hidden]="!selectedNumeroEntradas">

          <span class="menores-content-subtitle">Rellene la información de los menores</span>

          <div class="menores-content">
            <fotos-form-foto
              [numeroEntradas]="selectedNumeroEntradas"
              [compradorForm]="compradorForm"
              [formulario]="entradasForm"
              [fechaPartido]="fechaPartidoDate"
              (resumenChanged)="onResumenChanged($event)">
            </fotos-form-foto>
          </div>

        </span>

        <!-- RESUMEN FACTURA -->
        <div class="entrada-card factura" *ngIf="selectedNumeroEntradas!==0">
          <mat-card class="factura-card mt-6 resumen-card">
            <mat-card-header>
              <mat-card-title class="resumen-titulo">RESUMEN</mat-card-title>
            </mat-card-header>

            <div>
              <mat-divider class="resumen-divider full-width-divider"></mat-divider>
            </div>

            <mat-card-content>

              <!-- Fecha -->
              <div class="resumen-item">
                <mat-icon matTooltip="Día del partido" class="resumen-icon">event</mat-icon>
                <span>{{ fechaPartidoSeleccionado }}</span>
              </div>

              <!-- Hora -->
              <div class="resumen-item">
                <mat-icon matTooltip="Horario del partido" class="resumen-icon">schedule</mat-icon>
                <span>{{ horaPartidoSeleccionado }}</span>
              </div>

              <!-- Entradas -->
              <div class="resumen-item resumen-entradas">
                <mat-icon matTooltip="Entradas" class="resumen-icon">confirmation_number</mat-icon>
                <span>Entradas (x{{ resumenEntradas.noAbonados.count + resumenEntradas.abonados.count }})</span>
                <span class="resumen-precio">{{ resumenEntradas.total | number:'1.2-2' }}€</span>
              </div>

              <mat-divider class="resumen-divider"></mat-divider>

              <!-- Subtotal -->
              <div class="resumen-subtotal">
                <div>Subtotal</div>
                <div>{{ resumenEntradas.subtotal | number:'1.2-2' }}€</div>
              </div>

              <!-- Impuestos -->
              <div class="resumen-subtotal">
                <div>Impuestos</div>
                <div>{{ resumenEntradas.impuestos | number:'1.2-2' }}€</div>
              </div>

              <!-- Total -->
              <div class="resumen-total">
                <div>TOTAL</div>
                <div>{{ resumenEntradas.total | number:'1.2-2' }}€</div>
              </div>

            </mat-card-content>
          </mat-card>
        </div>

      </span>

      <span *ngSwitchCase="2">

      <span *ngSwitchCase="2">
        <div class="resumen-vertical-container" *ngIf="resumenEntradas">
          <div class="resumen-vertical-card">

            <div class="resumen-vertical-header">
              <mat-icon class="resumen-icon">receipt_long</mat-icon>
              <span class="resumen-vertical-titulo">Resumen de la compra</span>
            </div>

            <mat-divider class="resumen-divider full-width-divider"></mat-divider>

            <!-- Datos del partido -->
            <div class="resumen-vertical-section">
              <div class="resumen-item">
                <mat-icon>event</mat-icon>
                <span>{{ fechaPartidoSeleccionado }}</span>
              </div>

              <div class="resumen-item">
                <mat-icon>schedule</mat-icon>
                <span>{{ horaPartidoSeleccionado }}</span>
              </div>

              <div class="resumen-item">
                <mat-icon>sports_soccer</mat-icon>
                <span>{{ nombrePartidoSeleccionado }}</span>
              </div>
            </div>

            <mat-divider class="resumen-divider"></mat-divider>

            <!-- Entradas -->
            <div class="resumen-vertical-section">
              <div class="resumen-item resumen-entradas">
                <mat-icon>confirmation_number</mat-icon>
                <span>{{ (resumenEntradas?.noAbonados?.count || 0) + (resumenEntradas?.abonados?.count || 0) }} entradas</span>
              </div>

              <div class="resumen-subtotal">
                <div>Abonados</div>
                <div>{{ resumenEntradas?.abonados?.count || 0 }} ({{ resumenEntradas?.abonados?.total | number:'1.2-2' }} €)</div>
              </div>

              <div class="resumen-subtotal">
                <div>No abonados</div>
                <div>{{ resumenEntradas?.noAbonados?.count || 0 }} ({{ resumenEntradas?.noAbonados?.total | number:'1.2-2' }} €)</div>
              </div>
            </div>

            <mat-divider class="resumen-divider"></mat-divider>

            <!-- Totales -->
            <div class="resumen-vertical-section resumen-total-container">
              <div class="resumen-subtotal">
                <div>Subtotal</div>
                <div>{{ resumenEntradas?.subtotal | number:'1.2-2' }}€</div>
              </div>

              <div class="resumen-subtotal">
                <div>Impuestos</div>
                <div>{{ resumenEntradas?.impuestos | number:'1.2-2' }}€</div>
              </div>

              <div class="resumen-total">
                <div>Total</div>
                <div class="total-final">{{ resumenEntradas?.total | number:'1.2-2' }}€</div>
              </div>
            </div>

            <!-- Botón pagar -->
            <div class="resumen-pagar-container">

              <div class="condiciones-container-pago">
                <mat-checkbox [(ngModel)]="check1" class="condiciones-checkbox" required>
                  * He leído y acepto el
                  <a href="https://www.realbetisbalompie.es/media/files/rbetis/pdf/reglamento_visado_2024.pdf" target="_blank">Reglamento Interno del Club.</a> <strong>(Obligatorio)</strong>
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="check2" class="condiciones-checkbox" required>
                  * Declaro que he leído y acepto las
                  <a href="https://www.realbetisbalompie.es/media/files/rbetis/pdf/rbb.-_condiciones_de_compra_foto_once_inical_la_liga_temp._26-27._def.pdf" target="_blank">Condiciones de Compra y Participación en la actividad &quot;Foto 11 Inicial&quot;</a>,
                  incluida la política de cambios, cancelaciones y devoluciones.
                  <strong>(Obligatorio)</strong>
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="check3" class="condiciones-checkbox" required>
                  * Declaro ser el padre, madre o tutor legal del menor participante, o disponer de autorización suficiente para realizar su inscripción, y autorizo su participación en la actividad &quot;Foto 11 Inicial&quot;.
                  <strong>(Obligatorio)</strong>
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="check4" class="condiciones-checkbox" required>
                  * Autorizo la captación y el tratamiento de la imagen del menor exclusivamente para la realización, selección, edición, impresión y entrega de la fotografía objeto de la actividad, de acuerdo con la información sobre protección de datos facilitada.
                  <strong>(Obligatorio)</strong>
                </mat-checkbox>
                <mat-checkbox [(ngModel)]="check5" class="condiciones-checkbox">
                  Autorizo al Real Betis Balompié, S.A.D. a utilizar gratuitamente la imagen del menor captada durante la actividad en sus canales oficiales, página web, redes sociales, publicaciones y materiales informativos o promocionales del Club.
                  <strong><em>(Opcional)</em></strong>
                </mat-checkbox>
              </div>

              <button type="button" (click)="proceedToPay()" class="btn btn-primary">
                PAGAR
              </button>
            </div>
          </div>
        </div>
      </span>

      </span>

      <span *ngSwitchCase="3">
        <div class="step-result-wrapper">
          <div class="step-result-content">
          <ng-container *ngIf="statusResult === 'correcto'; else koBlock">
            <h2 class="success-title">Pago completado</h2>
            <p>Tu compra ha quedado registrada correctamente. Recibirás un correo con el resumen y el enlace para descargar las fotos.</p>
          </ng-container>
          <ng-template #koBlock>
            <h2 class="error-title">Pago no completado</h2>
            <p>No hemos podido procesar el pago. Puedes intentarlo de nuevo o contactar al club si el problema persiste.</p>
          </ng-template>
            <div class="step-result-actions">
              <button type="button" class="btn btn-primary" (click)="goToStart()">Volver al inicio</button>
            </div>
          </div>
        </div>
      </span>

    </span>

  </div>

  <div class="buttons-container">
    <button type="button" *ngIf="currentStep !== 3" [disabled]="!reservationActive" (click)="cancel()" class="btn">CANCELAR</button>
    <button type="button" *ngIf="currentStep===1" (click)="stepToPay()" class="btn btn-primary">PASAR AL PAGO</button>
    <button type="button" *ngIf="currentStep===2" [disabled]="!canGoStepBack" (click)="stepBack()" class="btn btn-primary">PASO ANTERIOR</button>
  </div>

</div>


